import React from "react";
import { HStack } from "@design-system/HStack/HStack";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { PlaidConnectionWithAccounts } from "@common/types/plaidConnection";
import { InvalidPlaidAccount } from "@common/dto/plaid/plaid-common";
import { AccountsConnectionWidget } from "../../financialAccount/AccountConnectionWidget/AccountsConnectionWidget";
import { PlaidInvalidAccountsList } from "./PlaidInvalidAccountsList";

interface Props {
    connection: PlaidConnectionWithAccounts;
    connectionSaved: boolean;
    foreign: InvalidPlaidAccount[] | null;
    hideAccountTypeSelection?: boolean;
}

export const PlaidAccountsConnectedModalBody: React.FC<Props> = ({
    connection,
    connectionSaved,
    foreign,
    hideAccountTypeSelection = false,
}) => {
    const accounts = connection.accounts;

    return (
        <>
            {connectionSaved && !hideAccountTypeSelection && (
                <AccountsConnectionWidget
                    heading={
                        <HStack align="center">
                            <InstitutionIcon
                                src={connection.bankLogoUrl}
                                size="xl"
                            />

                            <h6 className="ml-3">{connection.bankName}</h6>
                        </HStack>
                    }
                    accounts={accounts}
                    connection={connection}
                />
            )}

            {foreign && foreign.length > 0 && (
                <>
                    <p className="mt-3">
                        The following <strong>{connection.bankName}</strong>{" "}
                        accounts hold currency different than USD and are not
                        currently supported by Kick:
                    </p>
                    <PlaidInvalidAccountsList invalidAccounts={foreign} />
                </>
            )}
        </>
    );
};
